module.exports = __webpack_public_path__ + "assets/img/fomede_LIBER_pastel.30cdb4ff.png";